<template>
  <div><div>
    <div class="relative mx3 bb-mt2pt56">
      <div id="scrollView" class="bb-pl20p bb-xl-pl0 bb-pr20p bb-xl-pr40p bb-min-h20
        bb-ff2 bb-fs1pt2 bb-fc1 bb-ofy-auto bb-hyphens-auto border-box center bb-xl-justify">
        <div class="bb-ff2 bb-fs1pt2 bb-fc2">
          PRIVACY POLICY FOR BIG BANG SERVICES
        </div>
        <br/>
        <div class="bb-ff2 bb-fs1pt29 bb-fc3 mt1">
          Your privacy is important to us. 
        </div>
        <div class="bb-ff2 bb-fs1pt29 bb-fc3 mt1">
          This Privacy Statement describes the types of information Bigbang
          collects from and about you when you visit our website. 
        </div>
        <br/>
        <div class="bb-ff3 bb-fs1pt2 bb-fc1">
          COLLECTION AND USAGE
        </div>
        <br/>
        <div class="bb-ff2 bb-fs1pt29 bb-fc1">
          We’d like to get to know you
        </div>
        <div class="bb-ff2 bb-fs1pt29 bb-fc3 mt1">
          We collect information about your computer or device, e.g. your IP
          address. We might ask for your name, number, and email so we can
          ensure you have a great experience.
        </div>
        <br/>
        <div class="bb-ff2 bb-fs1pt2 bb-fc1">
          STORAGE
        </div>
        <br/>
        <div class="bb-ff2 bb-fs1pt29 bb-fc1">
          Your information is safe with us
        </div>
        <div class="bb-ff2 bb-fs1pt29 bb-fc3 mt1">
          We are very protective of the information that you provide us with and
          we have taken certain physical, administrative, and technical steps to
          safeguard the information we collect from and about our customers and
          Site visitors. We keep the data for as long as it is needed or
          required by law.
        </div>
        <br/>
        <div class="bb-ff2 bb-fs1pt2 bb-fc1">
          TRANSFER
        </div>
        <br/>
        <div class="bb-ff2 bb-fs1pt29 bb-fc1">
          Sharing information with others
        </div>
        <div class="bb-ff2 bb-fs1pt29 bb-fc3 mt1">
          We do not share your information with others unless you allow us to.
          We do share it with our affiliated companies and our third party
          service providers that provide business, professional or technical
          support functions for us, including to the extent necessary or
          desirable to complete your transaction.
        </div>
        <br/>
        <div class="bb-ff2 bb-fs1pt2 bb-fc1">
          CONTACT
        </div>
        <br/>
        <div class="bb-ff2 bb-fs1pt29 bb-fc1">
          The information about you
        </div>
        <div class="bb-ff2 bb-fs1pt29 bb-fc3 mt1">
          If you should have any questions about this Privacy Statement or the
          practices described herein, or, if you want to know what information
          we have on you, or if you wish to delete said information, please
          don’t hesitate to get in contact with us at Hello@bbangstudios.com
        </div>
      </div>
      <div id="scrollGradient" class="absolute bottom-0 left-0 right-0 bb-h25 bb-gradient1
        bb-events-none bb-transition2"></div>
    </div>
    <div class="absolute left-0 right-0 top-0 bottom-0 bb-zindexn1 bb-bc-black"></div>
  </div></div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  data () {
    return {
      scrollView: null
    }
  },
  methods: {
    scrollViewScrolled: function (event) {
      this.toggleGradient(event.target)
    },
    scrolledToEnd: function (el) {
      return el.scrollHeight - el.scrollTop <= el.clientHeight
    },
    resized: function () {
      this.calcScrollViewMaxHeight(this.scrollView)
      this.toggleGradient(this.scrollView)
    },
    calcScrollViewMaxHeight: function (el) {
      var windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
      var scrollViewY = el.getBoundingClientRect().top
      var footerHeight = document.getElementById('footer').offsetHeight
      var pageMarginBottom = 8 * parseFloat(getComputedStyle(document.documentElement).fontSize)
      el.style.maxHeight = windowHeight - scrollViewY - footerHeight - pageMarginBottom + 'px'
    },
    toggleGradient: function (el) {
      if (this.scrolledToEnd(el)) {
        document.getElementById('scrollGradient').classList.add('bb-op0')
      } else {
        document.getElementById('scrollGradient').classList.remove('bb-op0')
      }
    }
  },
  mounted () {
    this.scrollView = document.getElementById('scrollView')
    this.scrollView.addEventListener('scroll', this.scrollViewScrolled)

    window.addEventListener('resize', this.resized)

    this.calcScrollViewMaxHeight(this.scrollView)
    this.toggleGradient(this.scrollView)
  },
  destroyed () {
    this.scrollView.removeEventListener('scroll', this.scrollViewScrollEnd)
    window.removeEventListener('resize', this.resized)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
::-webkit-scrollbar-track {
  background-color: gray;
}

::-webkit-scrollbar {
  width: 0.5rem;
}

::-webkit-scrollbar-thumb {
  background-color: #ff3364; 
}
</style>



// WEBPACK FOOTER //
// src/components/privacyPolicy.vue